import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetArbetsorderAnteckningVirkesorderCommand extends BasicCommand<SetArbetsorderAnteckningVirkesorderCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    anteckningVirkesorder: string;
    constructor(init: (instance: SetArbetsorderAnteckningVirkesorderCommand) => void) {
        super("SetArbetsorderAnteckningVirkesorderCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
